import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import type { PaymentCompanySupportPhone_company$key } from './__generated__/PaymentCompanySupportPhone_company.graphql.ts';
import PaymentCompanySupportLink from './PaymentCompanySupportLink.tsx';
import { paymentCompanySupportParsePhoneNumber } from './paymentCompanySupportParsePhoneNumber.ts';

import type { ReactNode } from 'react';

type PaymentCompanySupportPhoneProps = {
  company: PaymentCompanySupportPhone_company$key;
};

const PaymentCompanySupportPhone = (
  props: PaymentCompanySupportPhoneProps,
): ReactNode => {
  const { t } = useTranslation();

  const company = useFragment<PaymentCompanySupportPhone_company$key>(
    graphql`
      fragment PaymentCompanySupportPhone_company on Company {
        preferences {
          support {
            phone
          }
        }
      }
    `,
    props.company,
  );

  if (!company?.preferences?.support?.phone) {
    return;
  }

  const parsedPhone = paymentCompanySupportParsePhoneNumber(
    company.preferences.support.phone,
  );

  if (!parsedPhone) {
    return;
  }

  return (
    <PaymentCompanySupportLink
      title={t('Seller phone')}
      href={`tel:${company.preferences.support.phone}`}
    >
      {parsedPhone.formatNational()}
    </PaymentCompanySupportLink>
  );
};

export default PaymentCompanySupportPhone;
